import * as React from "react";
import { colors, fonts, useMediaQuery } from "../../Styles";

interface ProgressStep_Props {
  title: string
  icon: JSX.Element
  opacity?: number
}

export default function ProgressStep({title, icon, opacity = 1}:ProgressStep_Props) {
  
  return (
    <div style={{opacity, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px"}}>
      {icon}
      <span style={{width: "100px", height:"fit-content", padding: "0px", textAlign: "center", ...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary}}>{title}</span>
    </div>
  );
}

interface ProgressSteps_Props {
  titles: string[]
  icons: JSX.Element[]
  opacityValues?: number[]
}
export function ProgressSteps({titles, icons, opacityValues = [1]}:ProgressSteps_Props) {
  const mobileXs = useMediaQuery(`(max-width: 690px)`);
  
  return (
    <div style={{ display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "center", gap: "0px", width: "fit-content" }}>
      {titles.map((_title, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <div style={{ opacity: opacityValues[index], height: "1px", width: mobileXs ? "10px" : "30px", marginTop: "25px", backgroundColor: colors.greyLightTertiary }} />
          )}
          <ProgressStep icon={icons[index]} title={titles[index]} opacity={opacityValues[index]} />
        </React.Fragment>
      ))}
    </div>
  )
}